import { AppRoutingConstants } from "src/app/routing/constants/app-routing-constants";

export class TdsRequestRoutingConstants extends AppRoutingConstants
{
    public static readonly TDS_REQUEST: string = "productinfo";
    public static readonly TDS_REQUEST_DOWNLOAD: string = "productinfo/download";
}